/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyByInvitationCodeResponse } from '../../models/company-by-invitation-code-response';

export interface GetCompanyByInvitationCode$Params {
  invitationCode: string;
}

export function getCompanyByInvitationCode(http: HttpClient, rootUrl: string, params: GetCompanyByInvitationCode$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyByInvitationCodeResponse>> {
  const rb = new RequestBuilder(rootUrl, getCompanyByInvitationCode.PATH, 'get');
  if (params) {
    rb.path('invitationCode', params.invitationCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompanyByInvitationCodeResponse>;
    })
  );
}

getCompanyByInvitationCode.PATH = '/api/companies/invitationCode/{invitationCode}';
